/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Approach
 */
export interface Approach {
    /**
     * 
     * @type {string}
     * @memberof Approach
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Approach
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof Approach
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof Approach
     */
    message: string;
}

/**
 * Check if a given object implements the Approach interface.
 */
export function instanceOfApproach(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "subject" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function ApproachFromJSON(json: any): Approach {
    return ApproachFromJSONTyped(json, false);
}

export function ApproachFromJSONTyped(json: any, ignoreDiscriminator: boolean): Approach {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'email': json['email'],
        'subject': json['subject'],
        'message': json['message'],
    };
}

export function ApproachToJSON(value?: Approach | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'email': value.email,
        'subject': value.subject,
        'message': value.message,
    };
}

